(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squish-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const observers = new Map();
    const init = root => {
      const homes = [...root.querySelectorAll('.sq-home')];
      if (root.matches?.('.sq-home')) homes.push(root);
      homes.forEach(home => {
        if (motion.matches || !('IntersectionObserver' in window) || observers.has(home)) return;
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('sq-revealed');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12 });
        home.querySelectorAll('[data-sq-reveal]').forEach((element,index) => {
          element.style.setProperty('--sq-delay', (index % 4) * 45 + 'ms');
          observer.observe(element);
        });
        observers.set(home,observer);
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:section:unload', event => {
      observers.forEach((observer,home) => {
        if (!event.target.contains(home)) return;
        observer.disconnect();
        observers.delete(home);
      });
    });
    motion.addEventListener('change', () => {
      observers.forEach(observer => observer.disconnect());
      observers.clear();
      if (!motion.matches) init(document);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
